import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { combineLatest, of } from 'rxjs';
import { groupBy, map, mergeMap, reduce, toArray } from 'rxjs/operators';
import { EventResource } from 'src/app/interfaces/event-resource';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';
import { PartnerService } from 'src/app/services/partner.service';
import { StatsService } from 'src/app/services/stats.service';
import { jsPDF } from "jspdf";
import 'jspdf-autotable'
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { McpService } from 'src/app/services/mcp.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { NavigationExtras, Router } from '@angular/router';
import { Interest } from 'src/app/interfaces/interest';
import { Configs } from './chart-configs'
import { DateValidator } from 'src/app/Validators/DateValidator';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}

/**
 * The Object used to load GoogleCharts
 */
declare var google: any;
/**
 * @ignore
 */
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  @ViewChild('userChart') userChart: ElementRef;
  @ViewChild('savingsChart') savingsChart: ElementRef;
  @ViewChild('attendenceChart') attendenceChart: ElementRef;
  @ViewChild('donutchart_0') donutchart_0: ElementRef;
  @ViewChild('donutchart_1') donutchart_1: ElementRef;
  @ViewChild('donutchart_2') donutchart_2: ElementRef;
  @ViewChild('donutchart_0_flop') donutchart_0_flop: ElementRef;
  @ViewChild('donutchart_1_flop') donutchart_1_flop: ElementRef;
  @ViewChild('donutchart_2_flop') donutchart_2_flop: ElementRef;



  //TODO check if this is forcing to many request when the mcp rest api is usable
  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    //this.drawCalenderChart();
    //this.drawChart();
  }
  fiterForm: UntypedFormGroup;
  calenderFilterForm: UntypedFormGroup;
  filterTestForm: UntypedFormGroup;
  public allEventsSortedBytotalActiveReservationsCount = [];
  public Image1: string;
  public doc = new jsPDF('p', 'pt', 'a4');
  SubCustomerCount: number = 0;
  partnerCount$ = this.partnerService.partnerCount$;
  eventCount$ = this.eventService.eventCount$;
  MainCustomerCount$ = this.businessuserService.MainCustomerCount$;


  public top1Event: EventResource = null;
  public top2Event: EventResource = null;
  public top3Event: EventResource = null;
  public flop1Event: EventResource = null;
  public flop2Event: EventResource = null;
  public flop3Event: EventResource = null;
  public sortOptions: SortOption[] = [];
  public events: SortOption[] = [];

  finishedLoadingFlopsAndTops: boolean = true;
  notEnoughEvents: boolean = false;;
  pdfIsDownloadable: boolean = false;
  pdfIsGenerating: boolean = false;
  startDate: Date = new Date();
  maxDate: Date = new Date();
  finishedLoadingLineChartUserCount: boolean = false;
  googlePlayStoreStats = null;
  appleAppStoreStats = null;
  googlePlayStoreStatsError = true;
  appleAppStoreStatsError = true;

  heighCalender = "1600px;"
  finishedLoadingCalendeData: boolean = false;
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  showUserDataAsTable: boolean = false;

  clientConfig;
  //Current Pos in Document
  pdfX = 0.0;
  pdfY = 0;;

  subusers = [];

  data_donut_1 = [];
  data_donut_2 = [];
  data_donut_3 = [];

  data_donut_1_flop = [];
  data_donut_2_flop = [];
  data_donut_3_flop = [];
  data_attendence = [];
  data_donut_types = [];
  data_donut_eventLimits = [];
  data_donut_voucherStrats = [];
  config_donut = Configs.config_donut;
  config_donut_types = Configs.config_donut_types;
  options_line = Configs.options_line;
  data_radar = Configs.data_radar;
  options_radar = Configs.options_radar;
  options_line_simple = Configs.options_line_simple;
  options_line_partners = Configs.options_line_partners;
  options_line_savings = Configs.options_line_savings;


  data_interest = [];
  data_savings = [];
  myControl = new UntypedFormControl();
  filteredOptions = [];
  filteredOptions_2 = [];
  filteredOptions_3 = [];
  optionsAuto = [];
  allActiveEvents = [];
  finishedLoadingComparison: boolean = true;
  hasEventV2: boolean = true;
  hasEventV1: boolean = true;
  isCalenderChartEmpty: boolean = true;
  config;
  allEvents: boolean = false;
  eventFilter = ["ACTIVE"];
  constructor(
    private statsService: StatsService,
    private eventService: EventService,
    private partnerService: PartnerService,
    private fb: UntypedFormBuilder,
    private businessuserService: BusinessuserService,
    private router: Router,
    private overlayService: OverlayService,
    private mcp: McpService) {

    google.charts.load('current', { 'packages': ['line', 'corechart', "calendar"], 'language': 'de' });
    this.startDate.setMonth(this.startDate.getMonth() - 6);

    this.fiterForm = this.fb.group({
      dropDownTime: ["", []],
      startDate: ["", []],
      endDate: ["", []],
    }, {
      validators: [
        DateValidator.is2MonthsApart('startDate', 'endDate')
      ]
    });

    this.filterTestForm = this.fb.group({
      serachForEvent: ["", [Validators.required]],
      serachForEvent_2: ["", [Validators.required]],
      serachForEvent_3: ["", [Validators.required]],
    })

    this.calenderFilterForm = this.fb.group({
      event: ["", []],
    })

    for (let index = 2; index < 13; index++) {
      this.sortOptions.push({
        value: '' + index * 30, viewValue: `Letze ${index} Monate`, state: false
      })
    }
  }


  ngAfterViewInit() {
    this.mcp.loadConfiguration().subscribe((val) => {
      this.clientConfig = val;
      this.drawChart()
    })

  }

  ngOnInit() {

    this.businessuserService.SubCustomerCount$.subscribe(subCutomers => {
      this.SubCustomerCount = subCutomers
    });

    this.eventService.searchForEvents(0, 1, ["ACTIVE"], null, null, null).subscribe((val: PagedResources<EventResource>) => {
      if (val.page.totalElements >= 1) {
        this.eventService.searchForEvents(0, val.page.totalElements, ["ACTIVE"], null, null, null).subscribe((val: PagedResources<EventResource>) => {
          this.allActiveEvents = val.content;
          this.filteredOptions = val.content;
          this.filteredOptions_2 = val.content;
          this.filteredOptions_3 = val.content;
        })
      }
    })
    let interestCount = [];
    let partnerCount = [];
    let eventTypes = [];

    this.eventService.searchForEvents(0, 1, ["ACTIVE"], null, null, null).subscribe((val: PagedResources<EventResource>) => {
      if (val.page.totalElements >= 1) {
        this.eventService.searchForEvents(0, val.page.totalElements, ["ACTIVE"], null, null, null).subscribe((val: PagedResources<EventResource>) => {
          val.content.forEach((element: EventResource) => {
            partnerCount.push(element.eventPartner);
            eventTypes.push(element);
          });

          const interestsByCount = interestCount.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.name]) {
              acc[value.name] = [];
            }
            // Grouping
            acc[value.name].push(value);
            return acc;
          }, {});

          const typesByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.eventDiscount]) {
              acc[value.eventDiscount] = [];
            }
            // Grouping
            acc[value.eventDiscount].push(value);
            return acc;
          }, {});

          const voucherStrategiesByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.voucherKeyStrategy]) {
              acc[value.voucherKeyStrategy] = [];
            }
            // Grouping
            acc[value.voucherKeyStrategy].push(value);
            return acc;
          }, {});

          const eventLimitByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.eventLimit]) {
              acc[value.eventLimit] = [];
            }
            // Grouping
            acc[value.eventLimit].push(value);
            return acc;
          }, {});

          const savingInPercentByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.savingInPercent]) {
              acc[value.savingInPercent] = [];
            }
            // Grouping
            acc[value.savingInPercent].push(value);
            return acc;
          }, {});

          Object.entries(savingInPercentByCount).forEach((element: any) => {
            this.data_savings.push({
              "group": element[0] + " %",
              "value": element[1].length
            })
          });

          Object.entries(interestsByCount).forEach((element: any) => {
            this.data_interest.push({
              "group": element[0],
              "value": element[1].length
            })
          });

          Object.entries(typesByCount).forEach((element: any) => {
            this.data_donut_types.push({
              "group": this.localeTranslateEventState(element[0]),
              "value": element[1].length
            })
          });

          Object.entries(eventLimitByCount).forEach((element: any) => {
            this.data_donut_eventLimits.push({
              "group": this.localeTranslateEventLimit(element[0]),
              "value": element[1].length
            })
          });

          Object.entries(voucherStrategiesByCount).forEach((element: any) => {
            this.data_donut_voucherStrats.push({
              "group": this.localeTranslateEventVoucherStrats(element[0]),
              "value": element[1].length
            })
          });


          this.data_interest = [...this.data_interest];
          this.data_donut_types = [...this.data_donut_types];
          this.data_donut_eventLimits = [...this.data_donut_eventLimits];
          this.data_donut_voucherStrats = [...this.data_donut_voucherStrats];
          this.data_savings = [...this.data_savings];
        })
      }
    })


  }

  moveToEventWithFilter() {
    let navigationExtras: NavigationExtras = {
      state: {
        filterState: ['ACTIVE']
      }
    };
    this.router.navigate(['caseworker/event'], navigationExtras)
  }

  moveToPartnersWithFilter() {
    let navigationExtras: NavigationExtras = {
      state: {
        filterState: ['ACTIVE']
      }
    };
    this.router.navigate(['caseworker/businessentity'], navigationExtras)
  }

  showAllEvents() {
    if (this.allEvents == true) {
      this.eventFilter = ["ACTIVE", "HIDDEN", "EXPIRED", "ARCHIVED"];
    } else {
      this.eventFilter = ["ACTIVE"];
    }
  }

  drawChart = () => {
    combineLatest([
      this.eventService.getTopThreeEvents(this.eventFilter, null, null, null)
    ]).pipe(
      map(([allEventsSorted]) => {
        console.log(allEventsSorted)
        if (allEventsSorted.length == 0) {
          this.notEnoughEvents = true;
        } else {
          this.allEventsSortedBytotalActiveReservationsCount = allEventsSorted;
          if (allEventsSorted.length >= 1) {
            this.top1Event = allEventsSorted[0];

            //Set Value for Select-Dropdown
            this.calenderFilterForm.patchValue({
              event: this.top1Event.publicId
            })

          }
          if (allEventsSorted.length >= 2) {
            this.top2Event = allEventsSorted[1];
          }
          if (allEventsSorted.length >= 3) {
            this.top3Event = allEventsSorted[2];
          }
          if (allEventsSorted.length >= 4) {
            this.flop1Event = allEventsSorted[allEventsSorted.length - 1];
          }
          if (allEventsSorted.length >= 5) {
            this.flop2Event = allEventsSorted[allEventsSorted.length - 2];
          }
          if (allEventsSorted.length >= 6) {
            this.flop3Event = allEventsSorted[allEventsSorted.length - 3];
          }

          if (allEventsSorted.length >= 3) {
            this.filterTestForm.patchValue({
              serachForEvent: this.top1Event.publicId,
              serachForEvent_2: this.top2Event.publicId,
              serachForEvent_3: this.top3Event.publicId,
            });
            this.filterEvents();
          }


          for (let index = 0; index < allEventsSorted.length; index++) {
            this.events.push({
              value: allEventsSorted[index]?.publicId, viewValue: allEventsSorted[index].title, state: false
            })
          }

          this.data_attendence = [...this.data_attendence]
          if (allEventsSorted.length >= 1) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[0]?.publicId).subscribe(value => {
              this.top1Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_1.push({
                "group": "Teilnahmen",
                "value": value.page.totalElements
              }, {
                "group": "Reservierungen",
                "value": allEventsSorted[0].totalActiveReservationsCount
              }, {
                "group": "Nicht eingelöst",
                "value": allEventsSorted[0].totalActiveReservationsCount - value.page.totalElements
              })

              this.data_donut_1 = [...this.data_donut_1];
            })
          }

          if (allEventsSorted.length >= 2) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[1]?.publicId).subscribe(value => {
              this.top2Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_2.push({
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
                {
                  "group": "Reservierungen",
                  "value": allEventsSorted[1].totalActiveReservationsCount
                }, {
                "group": "Nicht eingelöst",
                "value": allEventsSorted[1].totalActiveReservationsCount - value.page.totalElements
              })

              this.data_donut_2 = [...this.data_donut_2];
            })
          }

          if (allEventsSorted.length >= 3) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[2]?.publicId).subscribe(value => {
              this.top3Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_3.push(
                {
                  "group": "Teilnahmen",
                  "value": value.page.totalElements
                },
                {
                  "group": "Reservierungen",
                  "value": allEventsSorted[2].totalActiveReservationsCount
                }, {
                "group": "Nicht eingelöst",
                "value": allEventsSorted[2].totalActiveReservationsCount - value.page.totalElements
              })
              this.data_donut_3 = [...this.data_donut_3];
            })
            if (allEventsSorted.length >= 4) {
              this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop1Event?.publicId).subscribe(value => {
                this.flop1Event["attendanceCount"] = value.page.totalElements;

                this.data_donut_1_flop.push({
                  "group": "Teilnahmen",
                  "value": value.page.totalElements
                },
                  {
                    "group": "Reservierungen",
                    "value": this.flop1Event.totalActiveReservationsCount
                  }, {
                  "group": "Nicht eingelöst",
                  "value": this.flop1Event.totalActiveReservationsCount - value.page.totalElements
                })

                this.data_donut_1_flop = [...this.data_donut_1_flop];
              });
            }

            if (allEventsSorted.length >= 5) {
              this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop2Event?.publicId).subscribe(value => {
                this.flop2Event["attendanceCount"] = value.page.totalElements;
                this.data_donut_2_flop.push(
                  {
                    "group": "Teilnahmen",
                    "value": value.page.totalElements
                  },
                  {
                    "group": "Reservierungen",
                    "value": this.flop2Event.totalActiveReservationsCount
                  }, {
                  "group": "Nicht eingelöst",
                  "value": this.flop2Event.totalActiveReservationsCount - value.page.totalElements
                })
                this.data_donut_2_flop = [...this.data_donut_2_flop];
              });
            }
            if (allEventsSorted.length >= 6) {
              this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop3Event?.publicId).subscribe(value => {
                this.flop3Event['attendanceCount'] = value.page.totalElements;
                this.data_donut_3_flop.push(
                  {
                    "group": "Teilnahmen",
                    "value": value.page.totalElements
                  },
                  {
                    "group": "Reservierungen",
                    "value": this.flop3Event.totalActiveReservationsCount
                  },
                  {
                    "group": "Nicht eingelöst",
                    "value": this.flop3Event.totalActiveReservationsCount - value.page.totalElements
                  })
                this.data_donut_3_flop = [...this.data_donut_3_flop];
              });
            }
          } else {
            this.finishedLoadingFlopsAndTops = false;
          }
          this.drawCalenderChart();
        }
      })

    ).subscribe(() => {
      this.finishedLoadingFlopsAndTops = false;
    })
  }

  drawCalenderChart() {
    this.finishedLoadingCalendeData = false;
    document.getElementById('calendar_basic').style.display = 'block';
    this.isCalenderChartEmpty = false;

    var dataTable = new google.visualization.DataTable();
    dataTable.addColumn({ type: 'date', id: 'Date' });
    dataTable.addColumn({ type: 'number', id: 'Reservations' });
    //Get Count of all Reservations
    this.eventService.getReservationListForEvent(0, 1, this.calenderFilterForm.value.event).subscribe((value: PagedResources<any>) => {
      this.eventService.getReservationListForEventGroupBy(0, value.page.totalElements, this.calenderFilterForm.value.event, null).subscribe(value => {
        //Group by Date
        of(...value.content).pipe(
          groupBy((p: any) => p.created.split(' ')[0]),
          mergeMap(group$ =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map(arr => ({ date: arr[0], reservations: arr.slice(1) })),
          toArray()
        ).subscribe(p => {
          //Push Grouped Dates to DataArray
          if (p.length >= 1) {
            p.forEach(element => {
              dataTable.addRows([
                [new Date(element.date), element.reservations.length],
              ]);
            });
            //Group by Year for Height of Chart
            of(...p).pipe(
              groupBy((p: any) => p.date.split('-')[0]),
              mergeMap(group$ =>
                group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
              ),
              map(arr => ({ date: arr[0], reservations: arr.slice(1) })),
              toArray()
            ).subscribe(value => {
              ///Draw Chart
              var chart = new google.visualization.Calendar(document.getElementById('calendar_basic'));
              var options = {
                title: "",
                tooltip: { isHtml: true },
                calendar: {
                  cellSize: this.scaleCell(5, 20),
                  daysOfWeek: 'MDMDFSS',

                },
                //Calc Height of Chart based on the Grouped Years
                height: 270 * value.length
              }
              chart.draw(dataTable, options);
              //Set Spinnter to invisible
              this.finishedLoadingCalendeData = true;
              this.isCalenderChartEmpty = false;
            })
          } else {
            document.getElementById('calendar_basic').style.display = 'none';
            this.finishedLoadingCalendeData = true;
            this.isCalenderChartEmpty = true;
          }


        });
      })
    })
  }

  changeEventForCalenderChart(e) {
    this.drawCalenderChart();
  }

  scaleCell(min, max) {
    var cellSize = window.innerWidth / 60;
    if (cellSize > max) return max;
    if (cellSize < min) return min;
    return cellSize;
  }

  toggleUsersToggle(e: MatSlideToggleChange) {
    this.showUserDataAsTable = e.checked;
    if (e.checked == false) {
      this.drawChart();
    }
  }



  filterEvents() {
    if (this.filterTestForm.invalid) {
      return
    }
    this.finishedLoadingComparison = false;
    this.data_radar = [];
    combineLatest([
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent),
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent_2),
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent_3)
    ]).pipe(
      map(([event_1, event_2, event_3]) => {
        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_1?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(
            {
              "group": event_1.title,
              "key": "Teilnahmen",
              "value": value.page.totalElements
            },
            {
              "group": event_1.title,
              "key": "Reservierungen",
              "value": event_1.totalActiveReservationsCount
            },
            {
              "group": event_1.title,
              "key": "Nicht eingelöst",
              "value": event_1.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })

        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_2?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(
            {
              "group": event_2.title,
              "key": "Teilnahmen",
              "value": value.page?.totalElements
            },
            {
              "group": event_2.title,
              "key": "Reservierungen",
              "value": event_2.totalActiveReservationsCount
            },
            {
              "group": event_2.title,
              "key": "Nicht eingelöst",
              "value": event_2.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })

        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_3?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(
            {
              "group": event_3.title,
              "key": "Teilnahmen",
              "value": value.page?.totalElements
            },
            {
              "group": event_3.title,
              "key": "Reservierungen",
              "value": event_3.totalActiveReservationsCount
            },
            {
              "group": event_3.title,
              "key": "Nicht eingelöst",
              "value": event_3.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })



      })
    ).subscribe(val => {
      this.finishedLoadingComparison = true;
    })

  }

  localeTranslateEventState(event) {
    switch (event) {
      case "EXTERNAL_EVENT":
        return "Partneraktion";
      case "RAFFLE":
        return "Gewinnspiel";
      case "SERVICE_PLUS":
        return "Exklusiv";
      case "MONETARY":
        return "Preisvorteil";
      default:
        return event;
    }
  }


  localeTranslateEventLimit(limit) {
    switch (limit) {
      case "WITHOUT_LIMIT":
        return "Ohne Einschränkung";
      case "ADULT":
        return "Erwachsene (>= 18 Jahre)";
      case "YOUTH":
        return "unter 18-jährige";
      case "CHILDREN":
        return "Kinder (6-12 Jahre)";
      case "CHILDREN2":
        return "Kinder 2 (8-14 Jahre)";
      case "WOMAN_ONLY":
        return "Frauen (>=18 Jahre)";
      case "MAN_ONLY":
        return "Männer (>= 18 Jahre)";
      case "TEENAGER":
        return "Jugendliche (13-17 Jahre)";
      case "BABYS":
        return "Kleinkinder (0-5 Jahre)";
      default:
        return limit;
    }
  }
  localeTranslateEventVoucherStrats(limit) {
    switch (limit) {
      case "GATES":
        return "Gates Gutscheincodes";
      case "EXTERNAL_SINGLE_KEY":
        return "Aktionspartnercodes (einer)";
      case "EXTERNAL_KEY_LIST":
        return "Aktionspartnercodes (mehrere)";
      default:
        return limit;
    }
  }

}


